import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import { Toaster } from "@/components/ui/sonner";

const About = lazy(() => import("@/pages/About"));
const Services = lazy(() => import("@/pages/Services"));
const Projects = lazy(() => import("@/pages/Projects"));
const Products = lazy(() => import("@/pages/Products"));
const Technology = lazy(() => import("@/pages/Technology"));
const Media = lazy(() => import("@/pages/Media"));
const Careers = lazy(() => import("@/pages/Careers"));
const Contact = lazy(() => import("@/pages/Contact"));
const Terms = lazy(() => import("@/pages/Terms"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const PaymentPolicy = lazy(() => import("@/pages/PaymentPolicy"));
const RefundCancellation = lazy(() => import("@/pages/RefundCancellation"));
const AdminLayout = lazy(() => import("@/admin/AdminLayout"));
const AdminLogin = lazy(() => import("@/admin/pages/Login"));
const Dashboard = lazy(() => import("@/admin/pages/Dashboard"));
const AdminHeroSlides = lazy(() => import("@/admin/pages/HeroSlides"));
const AdminServices = lazy(() => import("@/admin/pages/Services"));
const AdminProjects = lazy(() => import("@/admin/pages/Projects"));
const AdminProducts = lazy(() => import("@/admin/pages/Products"));
const AdminTestimonials = lazy(() => import("@/admin/pages/Testimonials"));
const AdminNews = lazy(() => import("@/admin/pages/News"));
const AdminClients = lazy(() => import("@/admin/pages/Clients"));
const AdminRecognitions = lazy(() => import("@/admin/pages/Recognitions"));
const AdminStatistics = lazy(() => import("@/admin/pages/Statistics"));
const AdminContactInbox = lazy(() => import("@/admin/pages/ContactInbox"));
const AdminSettings = lazy(() => import("@/admin/pages/Settings"));
const AdminUsers = lazy(() => import("@/admin/pages/Users"));

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Suspense fallback={null}>
        <Routes>
          {/* Public site */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/products" element={<Products />} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/media" element={<Media />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/payment-policy" element={<PaymentPolicy />} />
            <Route path="/refund-cancellation" element={<RefundCancellation />} />
          </Route>

          {/* Admin CMS */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="hero-slides" element={<AdminHeroSlides />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="news" element={<AdminNews />} />
            <Route path="clients" element={<AdminClients />} />
            <Route path="recognitions" element={<AdminRecognitions />} />
            <Route path="statistics" element={<AdminStatistics />} />
            <Route path="contact-inbox" element={<AdminContactInbox />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="users" element={<AdminUsers />} />
          </Route>
        </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
